import { render } from "./ClientsSelect.vue?vue&type=template&id=2e67b980&lang=pug"
import script from "./ClientsSelect.vue?vue&type=script&lang=ts"
export * from "./ClientsSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script